import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import DropdownItem from "./DropdownItem";

interface CheckboxItemProps {
  selected: boolean;
  text: string;
  onClickFunction: (event?: any) => void;
}

const CheckboxItem: React.FC<CheckboxItemProps> = ({
  selected,
  text,
  onClickFunction,
}) => {
  return (
    <DropdownItem
      icon={
        selected ? (
          <MdCheckBox className="w-full h-full fill-neutral-700" />
        ) : (
          <MdCheckBoxOutlineBlank className="w-full h-full fill-neutral-700" />
        )
      }
      text={text}
      onClickFunction={onClickFunction}
      className="w-full max-w-[15vw] p-3 bg-white rounded-lg justify-start items-center gap-2 inline-flex text-neutral-700 hover:bg-neutral-50 cursor-pointer"
    />
  );
};

export default CheckboxItem;
